const initialState = { disputeData: [], disputesData: [], disputeJournalData: [], filteredData: [], edited: false, modified: false, disputeID: null };

export const DISPUTEREDUCER = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_DISPUTE':
            return {
                ...state,
                disputeData: action.data,
            }
        case 'GET_ALL_DISPUTES':
            return {
                ...state,
                disputesData: action.data,
                disputeJournalData: state.disputeJournalData
            }
        case 'GET_DISPUTE_JOURNAL':
            return {
                ...state,
                disputeJournalData: action.data,
                disputesData: state.disputesData,
            }
        case 'FILTER_DISPUTES':
            return {
                ...state,
                filteredData: action.data
            }
        case 'SET_EDIT':
            return {
                ...state,
                edited: action.data
            }
        case 'SET_MODIFIED':
            return {
                ...state,
                modified: action.data
            }
        case 'SET_DISPUTEID':
            return {
                ...state,
                disputeID: action.data
            }
        default:
            return state;
    }
}